import { atom } from 'recoil';

export const toggleQuickConfig = atom({
    key: 'pc-oracledb-19c-toggleQuickConfig',
    default: false,
});

export const quickConfigDetails = atom({
    key: 'pc-oracledb-19c-quickConfigDetails',
    default: undefined,
});

export const defaultVmDataDisk = atom({
    key: 'pc-oracledb-19c-defaultVmDataDisk',
    default: undefined,
});

export const toggleSspModels = atom({
    key: 'pc-oracledb-19c-toggleSspModels',
    default: {
        isCost: { costType: '', isCostOpen: false },
        isTagOpen: false,
        isApplicationOpen: false,
        isSubmitOrderSuccess: false,
        isUpdatedToCart: false,
        isCostSplitOpen: false,
        isDiskOpen: false,
        isDataDisk: { isOpen: false, newDataDiskCount: 0, deleteCount: 0 },
    },
});

export const isEnvDetailsLoading = atom({
    key: 'pc-oracledb-19c-isEnvDetailsLoading',
    default: false,
});

export const isDataDiskLoaded = atom({
    key: 'pc-oracledb-19c-isDataDiskLoaded',
    default: false,
});

export const isConfigDiskFulfilled = atom({
    key: 'pc-oracledb-19c-isConfigDiskFulfilled',
    default: false,
});

export const defaultOsDiskType = atom({
    key: 'pc-oracledb-19c-defaultOsDiskType',
    default: undefined,
});

export const isMandatoryTagsFullfilled = atom({
    key: 'pc-oracledb-19c-isMandatoryTagsFullfilled',
    default: false,
});

export const orderId = atom({
    key: 'pc-oracledb-19c-orderId',
    default: '',
});

export const isValidOwners = atom({
    key: 'pc-oracledb-19c-isValidOwners',
    default: {
        isvalidAppOwner: true,
    },
});

export const isCostcenterValid = atom({
    key: 'pc-oracledb-19c-isCostcenterValid',
    default: true,
});

export const sspSubmitOrder = atom({
    key: 'pc-oracledb-19c-sspOrder',
    default: {
        // Application Section
        appProfile: null,
        entityDetails: null,
        sector: null,
        sectorDetail: null,
        environment: null,
        landingZoneDetails: null,
        region: 'Dallas Data Center',
        dtc: 'Dallas Data Center',
        hCode: null,
        hCodeDetails: null,
        appOwner: null,
        appOwnerDetails: null,
        appTier: null,
        appTierCode: null,
        businessCategory: null,
        dataClassification: null,

        // Resource Section
        clusterDetails: null,
        clusterName: null,
        clusterVlans: [],
        vlanDetails: null,
        vlanName: null,
        osType: null,
        osName: null,
        osDisplayName: null,
        cpu: null,
        memoryGiB: null,
        quantity: 1,
        maxDataDiskCount: 8,
        dataDisksCount: null,
        dataDisks: [],
        defaultDataDisks: [],
        timeZone: null,
        displayTimeZone: null,
        billingEntity: null,
        billingEntityDetails: null,

        // Oracle Instance Section
        oracleVersion: '19C',
        dbNationalCharSet: null,
        dbCharacterSet: null,
        nvmeSupport: 'no',
        expDBSize: null,
        databaseName: '',
        isManualDBName: false,
        drPriority: null,
        metallic: null,
        backupTier: null,

        // Access Management Section
        domain: null,
        adous: null,
        adousDetails: null,
        adGroup: null,

        tags: [],
        estimatedCost: {
            details: [],
            qty: null,
            totalOneTimeCost: {
                frequency: 'one time',
                estCost: null,
                currency: 'USD',
            },
            totalRecurringCost: {
                frequency: 'monthly',
                estCost: null,
                currency: 'USD',
            },
            notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
        },
        catalogCode: null,
        placeNewOrder: new Date(),
        validationStatus: 'clearValidation',
        isTouched: false,
    },
});

export const costEstimateState = atom({
    key: 'pc-oracledb-19c-costEstimateState',
    default: null,
});

export const isLoadingCostApiState = atom({
    key: 'pc-oracledb-19c-isLoadingCostApiState',
    default: {
        isLoading: false,
    },
});

export const showisExistADGrp = atom({
    key: 'pc-oracledb-19c-showisExistADGrp',
    default: false,
});

export const isAppShortNameExist = atom({
    key: 'pc-oracledb-19c-isAppShortNameExist',
    default: false,
});

export const isAppShortNameValid = atom({
    key: 'pc-oracledb-19c-isAppShortNameValid',
    default: false,
});

export const CurrentServerDetails = atom({
    key: 'pc-oracledb-19c-CurrentServerDetails',
    default: null,
});

export const isDBNameValid = atom({
    key: 'pc-oracledb-19c-isDBNameValid',
    default: false,
});

export const isExpectedDbSizeValid = atom({
    key: 'pc-oracledb-19c-isExpectedDbSizeValid',
    default: false,
});
